export const CALENDAR_SELECTIONS_SESSION_STORAGE_KEY = 'calendarSelections';
export const storeCalendarSelections = _ref => {
  let {
    calendarSelections,
    session
  } = _ref;
  session.setItem(CALENDAR_SELECTIONS_SESSION_STORAGE_KEY, JSON.stringify(calendarSelections));
  return;
};
//# sourceMappingURL=storeCalendarSelections.js.map